import Analytics from '@/utils/analytics';
import PendingOrdersIcon from '@assets/icons/pending_orders.svg';
import React from 'react';
import {
  APP_MODAL_ROUTES,
  QUEUE_OFFLINE_ORDERS_ROUTES,
} from '@/navigators/routes';
import { AppModalStackParams } from '@/navigators/types';
import { SIZES } from '@/components/avatar';
import { StackNavigationProp } from '@react-navigation/stack';
import { StyleSheet, TouchableOpacity } from 'react-native';
import { useNavigation } from '@react-navigation/native';
import { useSalesRepMode } from '@/hooks/use-sales-rep-mode';
import { useTheme } from '@/contexts/theme-context';

const HIT_SLOP = {
  bottom: 8,
  left: 8,
  right: 8,
  top: 8,
};

type Navigation = StackNavigationProp<
  AppModalStackParams,
  APP_MODAL_ROUTES.QueuedOfflineOrders
>;

export const QueuedOfflineOrdersButton: React.FC = () => {
  const salesRepMode = useSalesRepMode();
  const theme = useTheme();
  const { navigate } = useNavigation<Navigation>();

  return (
    <TouchableOpacity
      hitSlop={HIT_SLOP}
      onPress={() => {
        Analytics.track('offline_mode.pending_orders_button.press');
        navigate(APP_MODAL_ROUTES.QueuedOfflineOrders, {
          screen: QUEUE_OFFLINE_ORDERS_ROUTES.Base,
        });
      }}
      style={styles.iconButton}
      testID="queued-offline-orders-button"
    >
      <PendingOrdersIcon
        stroke={salesRepMode ? theme.colors.white : theme.colors.primary}
      />
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  iconButton: {
    alignItems: 'center',
    marginHorizontal: 8,
    width: SIZES.small,
  },
});
